import { render, staticRenderFns } from "./Host.vue?vue&type=template&id=4598a03a"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"
import style0 from "./Host.vue?vue&type=style&index=0&id=4598a03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports